import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { koKR } from '@mui/x-data-grid/locales';
import { Box, Typography, Button, Autocomplete } from '@mui/material';
import api from '../api/axiosConfig';
import TextField from '@mui/material/TextField';

export default function CustomerAutocomplete({ onCustomerSelect }) {
    const [customerOptions, setCustomerOptions] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [customerInput, setCustomerInput] = useState('');
    const selectedOption = useMemo(() =>
        customerOptions.find(o => String(o.CUSTOMER_ID) === String(customerId)) || null,
        [customerOptions, customerId]
    );

    useEffect(() => {
        api
            .get(`/api/customer/customerList`)
            .then(res => {
                const uniq = (res.data || []).filter(
                    (it, idx, arr) => idx === arr.findIndex(t => t.CUSTOMER_ID === it.CUSTOMER_ID)
                );
                setCustomerOptions(uniq);
            })
            .catch(err => console.error("거래처 옵션 로드 실패:", err));
    }, []);
 

    return (
        <div>
            <div className="filter-item gh-field">
                <label>거래처</label>
                <Autocomplete
                    options={customerOptions}
                    value={selectedOption}
                    inputValue={customerInput}
                    onInputChange={(_, v) => setCustomerInput(v)}
                    onChange={(_, v) => {
                        const newCustomerId = v ? v.CUSTOMER_ID : '';
                        setCustomerId(newCustomerId);
                        
                        if (onCustomerSelect) {
                            onCustomerSelect(newCustomerId); 
                        }
                    }}

                    getOptionLabel={(o) => o?.CUSTOMER_NAME || ''}
                    isOptionEqualToValue={(o, v) => o?.CUSTOMER_ID === v?.CUSTOMER_ID}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="거래처 선택"
                            variant="standard"
                            InputProps={{ ...params.InputProps, disableUnderline: true }}
                            
                            sx={{ minWidth: 260 }}
                        />
                    )}
                    clearOnBlur={false}
                />
            </div>

        </div>

    );
}